'use client';

import { twBreakpoints } from '@woonstad/design-system';
import { useMediaQuery } from '@woonstad/helpers-hooks';
import Image from 'next/image';

type HeroImageProps = {
  afbeelding: {
    src: string;
  }
}

export const HeroImage = ({ afbeelding }: HeroImageProps) => {
  const isLarge = useMediaQuery(twBreakpoints['min-xs']);

  if (!afbeelding.src || !isLarge) {
    return null;
  }

  return (
    <Image
      className="size-full object-cover"
      src={afbeelding.src}
      alt={''}
      height={500}
      width={1000}
      sizes={`${twBreakpoints['max-md']} 90vw, 1000px`}
      priority
    />
  );
};
